import gql from 'graphql-tag';

export const INITIATE_WORKFLOW = gql`
  mutation InitiateWorkflow($deploymentModelId: Int!, $planningCycleId: Int!) {
    initiateWorkflow(input: { deploymentModelId: $deploymentModelId, planningCycleId: $planningCycleId }) {
      success
    }
  }
`;
